module.exports = __webpack_public_path__ + "img/adulto25.b24eb319.jpg";